import React from 'react';
import { styled, css } from 'styled-components';

/* Generate a star SVG.
 * When filled=false, the star will just be an outline
 * When filled=true, the star will have no outline
 * Percentage sets the width of the viewbox
 */
const getStarMask = (filled, percentage) => {
  const svg = `
    <svg viewBox="0 -0.5 ${16.5 * percentage} 16.5" xmlns="http://www.w3.org/2000/svg">
      <path fill="${filled ? 'black' : 'none'}" stroke="black" d="M7.51984 0.866635C7.67034 0.377789 8.32966 0.377787 8.48016 0.866637L9.66408 4.71221C9.85852 5.3438 10.4354 5.78461 11.1 5.78461H14.9935C15.4548 5.78461 15.7066 6.42209 15.2912 6.7406L12.0902 9.19512C11.5798 9.58651 11.3718 10.2592 11.5605 10.8723L12.771 14.804C12.9346 15.3353 12.3522 15.6687 11.9931 15.3933L8.90623 13.0263C8.36988 12.6151 7.63012 12.6151 7.09377 13.0263L4.00692 15.3933C3.64778 15.6687 3.06544 15.3353 3.22902 14.804L4.43945 10.8723C4.6282 10.2592 4.42021 9.58651 3.90979 9.19512L0.70875 6.7406C0.293373 6.42209 0.545228 5.78461 1.00648 5.78461H4.90003C5.56458 5.78461 6.14148 5.3438 6.33592 4.71221L7.51984 0.866635Z" />
    </svg>`;
  return `url('data:image/svg+xml,${encodeURIComponent(svg)}')`;
};
export const StyledStarContainer = styled.div.withConfig({
  componentId: "aui__sc-1jqglmd-0"
})(["position:relative;width:1rem;height:1rem;"]);
const commonStarStyles = css(["position:absolute;width:1rem;height:1rem;mask-repeat:no-repeat;"]);
export const StarFill = styled.div.withConfig({
  componentId: "aui__sc-1jqglmd-1"
})(["", ";mask-image:", ";background-color:", ";"], commonStarStyles, ({
  $percentage
}) => getStarMask(true, $percentage), ({
  $color
}) => $color === 'themed' ? 'var(--aui-primary)' : 'var(--aui-status-warning)');
export const StarOutline = styled.div.withConfig({
  componentId: "aui__sc-1jqglmd-2"
})(["", ";mask-image:", ";background-color:", ";"], commonStarStyles, getStarMask(false, 1.0), ({
  $color
}) => $color === 'themed' ? 'var(--aui-primary)' : 'var(--aui-status-on-warning)');
export const Star = ({
  color,
  percentage
}) => /*#__PURE__*/React.createElement(StyledStarContainer, null, /*#__PURE__*/React.createElement(StarFill, {
  $color: color,
  $percentage: percentage
}), /*#__PURE__*/React.createElement(StarOutline, {
  $color: color
}));